import React, { useState } from 'react';
import axios from 'axios';
import './MapSearch.css';

const MapSearch = ({ onLocationSelect }) => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [searching, setSearching] = useState(false);

    const handleSearch = async (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent parent form submission

        if (!query.trim()) return;

        setSearching(true);
        try {
            const response = await axios.get(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5`
            );
            setResults(response.data);
        } catch (error) {
            console.error('Error searching location:', error);
        } finally {
            setSearching(false);
        }
    };

    const handleSelect = (result) => {
        const lat = parseFloat(result.lat);
        const lng = parseFloat(result.lon);
        onLocationSelect({ lat, lng, displayName: result.display_name });
        setResults([]);
        setQuery('');
    };

    return (
        <div className="map-search-container">
            <div
                className="map-search-form"
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSearch(e);
                    }
                }}
            >
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="📍 Procurar morada ou local no mapa..."
                    className="map-search-input"
                    autoComplete="off"
                />
                <button
                    type="button"
                    className="map-search-btn"
                    disabled={searching}
                    onClick={handleSearch}
                >
                    {searching ? '🔄' : '🔍'}
                </button>
            </div>

            {results.length > 0 && (
                <ul className="search-results">
                    {results.map((result) => (
                        <li key={result.place_id} onClick={() => handleSelect(result)}>
                            📍 {result.display_name}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default MapSearch;
